import { PrimitiveValueObject } from '../../../../utility/model/primitive-value-object.model';

export class AccountShortImg extends PrimitiveValueObject<string> {
  static create(value: string): AccountShortImg {
    return new AccountShortImg(value);
  }
}
